import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { ColorUtils } from "../../utils/ColorUtils";

export const Accordion = styled((props: AccordionProps) => <MuiAccordion defaultExpanded disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    "&:before": {
      display: "none",
    },
  })
);

export const AccordionSummary = styled((props: { title: string; icon: JSX.Element; closable?: boolean, activeSection?: boolean, closed: boolean }) => {
  const { title, icon, closable = true, activeSection = false, closed } = props;
  return (
    <MuiAccordionSummary
      style={activeSection ? {backgroundColor: "#FAEEE1" , color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING } : {}}
      sx={closable ? undefined : { cursor: "default !important" } }
      expandIcon={closable ? <ExpandMoreIcon sx={{ fontSize: "0.1rem" }} /> : undefined}
      {...props}
    >
      <ListItemIcon className={activeSection && closed ? "active closed" : activeSection ? "active" : closed ? "closed" : ""}>
        {icon}
      </ListItemIcon>
      <ListItemText className={activeSection && closed ? "active closed" : activeSection ? "active" : closed ? "closed" : ""}>
        {closed ? capitalizeFirstLetters(title) : title}
      </ListItemText>
    </MuiAccordionSummary>
  );
})(({ theme }) => ({
  justifyContent: "flex-start",
  backgroundColor: "none",
  "& .active span": {
    color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING
  },
  "& .active svg": {
    color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING
  },
  "& .closed svg": {
    marginLeft: "-10px",
  },
  "&.MuiAccordionSummary-root":{
    marginTop: "5px",
    marginRight: "10px",
    marginLeft: "10px",
    borderRadius: "10px"
  },
  "& .MuiAccordionSummary-content": {
    height: "30px",
    marginRight: theme.spacing(0),
  },
  "& .MuiListItemIcon-root": {
    minWidth:"35px"
  },
  '& span': {
    fontSize: '0.9rem',
    color: "gray"
  },
  '& svg': {
    fontSize: '1.4rem',
    color: "gray"
  }
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(1),
  backgroundColor: 'theme.palette.background.paper',
}));

function capitalizeFirstLetters(input: string): string {
  return input.split(' ')
              .filter(word => word.length > 0) // remove empty strings
              .map(word => word.charAt(0).toUpperCase())
              .join('');
}